import React, { useMemo } from 'react';

import styled from 'styled-components';

import CollaboratorsEdit from './CollaboratorsEdit';
import OwnersEdit from './OwnersEdit';

export const EmployeesEditContext = React.createContext({});

export default function EmployeesEdit({ className, employees, children, onUpdate }) {
  const context = useMemo(
    () => ({
      employees,
      onUpdate,
    }),
    [JSON.stringify(employees || []), onUpdate]
  );
  return (
    <Container className={className} onClick={(e) => e.stopPropagation()}>
      <EmployeesEditContext.Provider value={context}>{children}</EmployeesEditContext.Provider>
    </Container>
  );
}

EmployeesEdit.OwnersEdit = OwnersEdit;
EmployeesEdit.CollaboratorsEdit = CollaboratorsEdit;

const Container = styled.div``;
